// Imperative navigation for code outside React components (redux actions,
// error boundary). Keeps the old `history.push/replace/goBack` call sites
// working on top of the react-router data router.
let routerInstance = null;

export const setRouter = (router) => {
  routerInstance = router;
};

const navigate = (to, options) => {
  if (!routerInstance) {
    throw new Error('Router is not initialized');
  }
  return routerInstance.navigate(to, options);
};

const history = {
  push: to => navigate(to),
  replace: to => navigate(to, { replace: true }),
  goBack: () => navigate(-1),
};

export default history;
